import { render, staticRenderFns } from "./PgaSingleNotification.vue?vue&type=template&id=11445260&"
import script from "./PgaSingleNotification.vue?vue&type=script&lang=ts&"
export * from "./PgaSingleNotification.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VIcon,VListItemSubtitle,VListItemTitle,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11445260')) {
      api.createRecord('11445260', component.options)
    } else {
      api.reload('11445260', component.options)
    }
    module.hot.accept("./PgaSingleNotification.vue?vue&type=template&id=11445260&", function () {
      api.rerender('11445260', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/feature/Shared/Notification/Components/PgaSingleNotification.vue"
export default component.exports